export const pageName = {
  1: "/personal-details",
  2: "/professional-details",
  3: "/achievements",
  4: "/confirmation",
  5: "/download-document",
};
